<script>

/**
 * Nav-bar Component
 */
export default {
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  mounted() {
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table table-borderless">
      <tbody>
      <tr>
        <th scope="row">Image :</th>
        <td><img :src="'/api/partners/' + resource.id + '/image'" :alt="resource.name"></td>
      </tr>
      <tr>
        <th scope="row">Nom :</th>
        <td>{{ resource.name }}</td>
      </tr>
      <tr>
        <th scope="row">URL :</th>
        <td><a :href="resource.url">{{ resource.url }}</a></td>
      </tr>
      <tr>
        <th scope="row">Description :</th>
        <td>{{ resource.description }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
